import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import { getTimerObject } from '../../../utils/dateUtils';
import Text from '../../../atoms/Text';
import styles from './index.pcss';

const cx = classNames.bind(styles);

interface EventTimerProps {
  platform?: string;
  variant?: string;
  color?: string;
  weight?: string;
  title: string;
  eventDate: number;
  timerClass?: string;
  rootTextColorClass?: string;
  onTimerComplete: () => void;
  topLevelComponent?: string;
}

const EventTimer = (props: EventTimerProps): JSX.Element | null => {
  const {
    platform = '',
    variant = 'T2',
    color = 'Nero',
    weight = 'regular',
    title = '',
    eventDate = 0,
    onTimerComplete,
    timerClass,
    rootTextColorClass,
    topLevelComponent = ''
  } = props;
  const [timer, setTimer] = useState('');

  const getTime = (): void | null => {
    const timeFormat = new Date(eventDate).getTime();

    if (timeFormat - new Date().getTime() > 0) {
      const x = setInterval(() => {
        const timeString = getTimerObject(eventDate);
        if (timeString) {
          setTimer(timeString);
        } else {
          clearInterval(x);
          // onTimerComplete();
          if (timeString === '' && topLevelComponent === 'EventCard') {
            try {
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            } catch (e) {}
          }
          setTimer('');
        }
      }, 1000);
    }
  };

  useEffect(() => {
    if (eventDate) getTime();
  }, []);

  if (!timer) {
    if (topLevelComponent === 'upcoming') {
      return <div className={cx('timer-cta', timerClass)}>&nbsp;</div>;
    }
    return null;
  }

  return (
    <div className={cx('timer-cta', timerClass)}>
      <Text variant={variant} weight={weight} color={`${rootTextColorClass || 'Nero'}`}>
        {title}
        {` `}
        <Text variant={variant} weight={weight} color={color}>
          {timer}
        </Text>
      </Text>
    </div>
  );
};

EventTimer.defaultProps = {
  platform: '',
  topLevelComponent: '',
  rootTextColorClass: '',
  timerClass: '',
  variant: 'T2',
  color: 'Nero',
  weight: 'regular'
};

export default EventTimer;
